export const defaultFormValues = {
  1: {
    pickupLocation: null,
    destinationLocation: null,
    isCustomDestination: false,
    numberOfPassengers: "1",
    customDestination: "",
    roundTripReservation: true,
    selectedCar: null,
  },
  2: {
    numberOfPassengers: "1",
    selectedCar: null,
  },
  3: {
    locationIsAirport: {
      arrivalAirline: "",
      bookingDate: null,
      bookingTime: null,
      arrivalFlightNumber: "",
      bookingDetailsNotes: "",
      signName: "",
    },
    destinationIsAirport: {
      bookingDetailsNotes: "",
      departureAirline: "",
      departureDate: null,
      departureFlightNumber: "",
      departureTime: null,
    },
    bothIsAirport: {
      bookingDate: null,
      bookingTime: null,
      arrivalAirline: "",
      arrivalFlightNumber: "",
      bookingDetailsNotes: "",
      signName: "",
      departureAirline: "",
      departureDate: null,
      departureFlightNumber: "",
      departureTime: null,
    },
    roundTrip: {
      bookingDate: null,
      bookingTime: null,
      arrivalAirline: "",
      arrivalFlightNumber: "",
      bookingDetailsNotes: "",
      signName: "",
      departureAirline: "",
      departureDate: null,
      departureFlightNumber: "",
      departureTime: null,
    },
    noneIsAirport: {
      bookingDate: null,
      bookingDetailsNotes: "",
      bookingTime: null,
    },
  },
  4: {
    Addon: {},
  },
  5: {
    additionalPhone: "",
    address: "",
    address2: "",
    country: "",
    city: "",
    state: "",
    confirmEmailAddress: "",
    emailAddress: "",
    firstName: "",
    lastName: "",
    mobilePhone: "",
    postalCode: "",
  },
  6: {
    couponCode: "",
    paymentVariant: null,
    termsAndCondition: false,
  },
};

// eslint-disable-next-line no-useless-escape
export const EMAIL_VALIDATION_PATTERN = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/;

export const affiliateIdCookieName = "affiliateId";
